// src/components/welcome/GentleIntro.js
import React from "react";
import { Link } from "react-router-dom";
import { Heading } from "@chakra-ui/react";

const GentleIntroPage = () => {
  return (
    <div className="about-container">
      <Heading
        as="h1"
        size="xl"
        className="about-title"
        style={{
          background: 'linear-gradient(60deg, #E27A47 35%, #4BB19D 55%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        Welcome to Axy
      </Heading>

      <section className="welcome-section" style={{ marginBottom: '1rem' }}>
        <Heading
          as="h3"
          size="md"
          className="gentle-intro-heading"
          style={{
            background: 'linear-gradient(60deg, #E27A47 35%, #4BB19D 55%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
          }}
        >
          <Link to="/agenda">Agenda <span style={{ marginLeft: '5px' }}><i className="far fa-calendar-alt"></i></span></Link>
        </Heading>
        <p className="welcome-text">Browse and plan your program</p>
      </section>

      <section className="welcome-section" style={{ marginBottom: '1rem' }}>
        <Heading
          as="h3"
          size="md"
          className="gentle-intro-heading"
          style={{
            background: 'linear-gradient(60deg, #E27A47 35%, #4BB19D 55%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
          }}
        >
          <Link to="/discover">Discover <span style={{ marginLeft: '5px' }}><i className="pi pi-sparkles"></i></span></Link>
        </Heading>
        <p className="welcome-text">Axy's AI picks abstracts for you</p>
      </section>

      <section className="journey-section" style={{ marginBottom: '1rem' }}>
        <Heading
          as="h3"
          size="md"
          className="gentle-intro-heading"
          style={{
            background: 'linear-gradient(60deg, #E27A47 35%, #4BB19D 55%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
          }}
        >
          <Link to="/whats-hot"> What's Hot <span style={{ marginLeft: '5px' }}><i className="fa-solid fa-fire"></i></span></Link>
        </Heading>
        <p className="journey-text">See what others are liking</p>
      </section>

      <section className="journey-section" style={{ marginBottom: '1rem' }}>
        <Heading
          as="h3"
          size="md"
          className="gentle-intro-heading"
          style={{
            background: 'linear-gradient(60deg, #E27A47 35%, #4BB19D 55%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
          }}
        >
          <Link to="/jobs">Jobs <span style={{ marginLeft: '5px' }}><i className="fa-solid fa-suitcase"></i></span></Link>
        </Heading>
        <p className="journey-text">Post or find jobs here: <span style={{ marginLeft: '5px' }}><Link to="/jobs"><i className="fa-solid fa-suitcase"></i></Link></span></p>
      </section>
      <section className="journey-section" style={{ marginTop: '3rem' }}>
        <Heading
          as="h3"
          size="md"
          className="gentle-intro-heading"
          style={{
            background: 'linear-gradient(60deg, #E27A47 35%, #4BB19D 55%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
          }}
        >
          About <span style={{ marginLeft: '5px' }}><Link to="/about"><i className="fas fa-info-circle"></i></Link></span>
        </Heading>
        <p className="journey-text"><Link to="/about"><u>About Axy</u></Link>. <a href="https://forms.gle/Pje8D72vqVr7Txre6" className="feedback-link">Feedback form</a>.</p>
      </section>
    </div>
  );
};

export default GentleIntroPage;
